<template lang="pug">
    .accordion-wrap(:class="[spacingTop, spacingBottom]")
        .container.mx-auto
            .accordion
                Panel(
                    v-for="( panel, i ) in accordion"
                    :key="panel.id"
                    :index="i"
                    :panel="panel"
                )
</template>

<script>

import { get , cloneDeep } from '@/helpers';

import Panel from './Panel'

export default {
    name: 'Accordion',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Panel,
    },
    computed: {
        accordion() {
            let accordion = this.section.contents || []
            return cloneDeep(accordion).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0))
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
}
</script>


<style lang="sass" scoped></style>
